__turbopack_context__.v({
  "button": "error-boundary-module-sass-module__O9-BGq__button",
  "container": "error-boundary-module-sass-module__O9-BGq__container",
  "text": "error-boundary-module-sass-module__O9-BGq__text",
});
